import { IOrganization } from 'types/models/OrganizationModels';
import { UserDiagnosticsState, UserDiagnosticsTag } from 'types/models/UserDiagnosticsModel';

export const filterHasLicense = (license: string[], organization: IOrganization) => {
    return organization.licenses && !!license.every((l) => organization.licenses.includes(l));
};

export const getLicenseFilterOptions = (licenses: string[]) => {
    return licenses.map(type => ({
        value: type,
        label: type
    }));
};

export const filterHasUserDiagnosticState = (value: string, state: UserDiagnosticsState) => {
    const enumValue = UserDiagnosticsState[value as keyof typeof UserDiagnosticsState];
    return enumValue === state;
};

export const filterHasUserDiagnosticTags = (tagStrings: string[], userDiagnosticsTags: UserDiagnosticsTag[] | null): boolean => {
    const userTags = userDiagnosticsTags ?? [];

    const requiredTags = tagStrings
        .map(tag => (UserDiagnosticsTag as any)[tag])
        .filter((tag): tag is UserDiagnosticsTag => typeof tag === "number");

    return requiredTags.every(tag => userTags.includes(tag));

};


// TypeScript numeric enums are bi-directional, meaning Object.entries will include both:
// - forward mappings: ["New", 0]
// - reverse mappings: [0, "New"]
// To avoid duplicate entries and ensure we only process the named enum members,
// we filter out entries where the value is not a number.
export function getEnumFilterOptions<T extends Record<string, string | number>>(enumObj: T) {
    return Object.entries(enumObj)
        .filter(([key, value]) => typeof value === "number")
        .map(([key]) => ({
            value: key,
            label: key
        }));
}
